import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BotCostHeatmap = ({ bots }) => {
  // Dynamically extract the cost types (keys) excluding botName
  const costTypes = Object.keys(bots[0]).filter((key) => key !== "botName");

  // Generate datasets dynamically based on the cost types
  const datasets = costTypes.map((costType, index) => ({
    label: costType.replace(/([A-Z])/g, " $1").trim(),
    data: bots.map((bot) => bot[costType] || 0),
    backgroundColor: `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(
      Math.random() * 255
    )}, ${Math.floor(Math.random() * 255)}, 0.5)`, // Random color for each dataset
  }));

  const formatToScientific = (value) => {
    // if (value === 0) return "0";
    // const exponent = Math.floor(Math.log10(Math.abs(value)));
    // const mantissa = (value / Math.pow(10, exponent)).toFixed(3);
    // return `$${mantissa} × 10^${exponent}`;

    if (value === 0) return value; // Return 0 as is

    const exponent = Math.floor(Math.log10(Math.abs(value)));
    const mantissa = (value / Math.pow(10, exponent)).toFixed(2); // Mantissa with 2 decimal places

    // If the exponent is between -2 and 2 (inclusive), return the rounded value with 2 decimal places
    if (exponent >= -2 && exponent <= 2) {
      return Number(value).toFixed(2);
    }

    // Otherwise, return the mantissa and exponent in scientific notation
    return (
      <>
        {mantissa} &times; 10<sup>{exponent}</sup>
      </>
    );
  };

  const formatToScientificForAxis = (value) => {
    if (value === 0) return value.toString(); // Return 0 as a string

    const exponent = Math.floor(Math.log10(Math.abs(value)));
    const mantissa = (value / Math.pow(10, exponent)).toFixed(2); // Mantissa with 2 decimal places

    // If the exponent is between -2 and 2 (inclusive), return the rounded value as a string
    if (exponent >= -2 && exponent <= 2) {
      return Number(value).toFixed(2).toString();
    }

    // Return the mantissa and exponent as a string in scientific notation
    return `${mantissa} × 10^${exponent}`;
  };

  const data = {
    labels: bots.map((bot) => bot.botName),
    datasets: datasets,
  };

  const options = {
    plugins: {
      title: {
        display: true,
        text: "Bot Cost Heatmap",
        color: "#ffffff",
      },
      legend: {
        labels: {
          color: "#ffffff",
        },
      },
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: "#ffffff", // X-axis labels color for dark background
        },
        grid: {
          color: "rgba(255, 255, 255, 0.1)", // Grid color for dark background
        },
      },
      y: {
        stacked: true,
        ticks: {
          color: "#ffffff",
          callback: (value) => formatToScientificForAxis(value), // Format Y-axis labels
        },
        grid: {
          color: "rgba(255, 255, 255, 0.1)", // Grid color for dark background
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default BotCostHeatmap;
